import { qfetch } from "@qgiv/core-js";

// send api call for error
const errorUrl = "/api/v1/internal/react_app_crash";

const submitErrorData = (data) => qfetch.post(errorUrl, data);

export default submitErrorData;
